import { APP_VERSION, COMPUTED_EXPERIENCE_ID, ENV, ESTABLISHMENT_ID, ESTABLISHMENT_REGION_ID, ESTABLISHMENT_SOUS_REGION_ID, HOME_PATH, HOME_PATH_NAME, IFRAME_LOCALE, INITIAL_APP_URL, LOCALE, WITH_REVIEWS } from '@/constants/config';
import { FGTMEventEnum } from '@/types/gtm';
import { v4 } from 'uuid';
const initializeGTM = (cb) => {
    window.dataLayer = window.dataLayer || [];
    window.pageReferrer = document.referrer;
    window.pageReferrerName = `Partner ${ESTABLISHMENT_ID}`;
    window.dataLayer.push({
        app_language: LOCALE,
        app_version: APP_VERSION,
        application_env: ENV,
        device_language: typeof navigator !== 'undefined' ? navigator.language : 'unknown',
        establishment_id: ESTABLISHMENT_ID,
        id_region: ESTABLISHMENT_REGION_ID,
        id_sous_region: ESTABLISHMENT_SOUS_REGION_ID,
        experience_id: COMPUTED_EXPERIENCE_ID,
        iframe_language: IFRAME_LOCALE ?? 'undefined',
        iframe_url: INITIAL_APP_URL,
        platform: 'widget',
        custom_page_path: HOME_PATH,
        page_name: HOME_PATH_NAME,
        page_referrer: window.pageReferrer,
        page_referrer_name: window.pageReferrerName,
        referrer: window.pageReferrer,
        referrer_name: window.pageReferrerName,
        starting_page_path: HOME_PATH,
        starting_page_name: HOME_PATH_NAME,
        with_reviews: WITH_REVIEWS,
        session_token: v4()
    });
    // Add the GTM initialization code
    window.dataLayer.push({
        event: FGTMEventEnum.gtm_js,
        gtm: {
            start: new Date().getTime()
        }
    });
    cb();
};
export default initializeGTM;
